import React from 'react'

import Page from '../../../components/pdf/Page'
import BmTable from './BmTable'

const PdfDocument = ({ templateId }) => {
  return (
    <Page>
      <BmTable templateId={templateId} />
    </Page>
  )
}

export default PdfDocument
